import axios from '@_system/axios/axios.js'
export default {
	path: '/goodsgroup',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/goodsgroup.goodsgroup', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	import(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	goodsimport(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/goodsimport/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	goodsexport(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/goodsexport', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	// getgoodsbyonlinecode(code,data = {}) {
	// 	return new Promise((resolve,reject) => {
	// 		axios.post(this.path + '/getgoodsbyonlinecode/'+code, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },	
	pull(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/pull', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},		
	
	
	// list(data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.get(this.path, data, (res) => {
	// 			resolve(res.data)
	// 		}, reject)
	// 	})
	// },
	// get(id, data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.get(this.path + '/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		}, reject)
	// 	})
	// },
	// push(data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.post(this.path + '/push', data, (res) => {
	// 			resolve(res.data)
	// 		}, reject)
	// 	})
	// },

	// getgoods(id, data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.post(this.path + '/getgoods/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		}, reject)
	// 	})
	// },
	// pull(data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.post(this.path + '/pull', data, (res) => {
	// 			resolve(res.data)
	// 		}, reject)
	// 	})
	// },

	// delete(id, data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.delete(this.path + '/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		}, reject)
	// 	})
	// },
	// init(data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.get('moduleConfig/admin/goodsgroup.goodsgroup', data, (res) => {
	// 			resolve(res.data)
	// 		}, reject, true)
	// 	})
	// },

}
